import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';

import { GET_CLIENT_REGION, GET_CLIENT_REGION_SUCCESS, GET_CLIENT_REGION_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getClientRegion({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/vendor/regions`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload.urlParam,
        pageIndex: 0,
        pageSize: 8000,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_CLIENT_REGION_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_CLIENT_REGION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_CLIENT_REGION_ERROR, payload: error });
  }
}

export function* watchGetClientRegion() {
  yield takeEvery(GET_CLIENT_REGION, getClientRegion);
}

function* getClientRegionSaga() {
  yield all([fork(watchGetClientRegion)]);
}

export default getClientRegionSaga;
